import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchLoginActivitiesFromAPI } from "../../../services/LoginActivityService";

export const fetchLoginActivities = createAsyncThunk(
  "loginActivity/fetchLoginActivities",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchLoginActivitiesFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data login activity");
    }
  }
);

const loginActivitySlice = createSlice({
  name: "loginActivity",
  initialState: {
    activities: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    activitySearch: "",
    loading: false,
    error: null,
    totalCount: 0,
    users: 0,
    ips: 0,
    keywordSearch: "",
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchActivity: (state, action) => {
      state.activitySearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
    resetLoginActivityState: (state) => {
      state.activities = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoginActivities.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoginActivities.fulfilled, (state, action) => {
        const activities = action.payload.activities;
        state.loading = false;
        state.activities = activities.data || [];
        state.totalCount = activities.pagination?.total ?? (activities.data?.length || 0);
        state.currentPage = activities.pagination?.page ?? 1;
        state.perPage = activities.pagination?.per_page ?? state.perPage;
        state.users = activities.users ?? 0;
        state.ips = activities.ips ?? 0;
      })
      .addCase(fetchLoginActivities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSearchActivity, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters, resetLoginActivityState } = loginActivitySlice.actions;
export default loginActivitySlice.reducer;

